export const WIDGET_ID = "widget-insights";
